import { createClient } from '@supabase/supabase-js';

import { env } from './env';

/** Single browser Supabase client. Used for auth only; data goes through the API. */
export const supabase = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});
